import PaymentFormPaySafe from '../paysafe/PaymentFormPaysafe';
import { usePaymentContext } from '../../contexts/PaymentContext';
import PaymentFormTotalProcessing from '../totalprocessing/PaymentFormTotalProcessing';

const MultiProviderPayment = ({ ctaText, redirectUrl, blurInfos, setBlurInfos }) => {
    const { provider } = usePaymentContext();
    return (
        <>
            {provider === 0 && <PaymentFormTotalProcessing blurInfos={blurInfos} setBlurInfos={setBlurInfos}/>}
            {provider === 3 && <PaymentFormPaySafe ctaText={ctaText} redirectUrl={redirectUrl} />}
        </>
    );
};

export default MultiProviderPayment;
